<div class="component-wrapper h-100 scroll-y" [ngStyle]="contentStyle">
  <!-- Wrapper div to avoid showing the search input and currencies list in the same row -->
  <div>
    @if (widgetAttributes.widgetProperties.inputFieldSettings?.isAllowed) {
    <div class="search-input w-100">
      <finxone-input
        [type]="'text'"
        [name]="'searchCurrency'"
        [placeholder]="widgetAttributes.widgetProperties.inputFieldSettings?.label ?? ''"
        (input)="searchCurrencies($event)"
      >
        <span prefix class="prefix-icon">
          <mat-icon
            [ngStyle]="searchIconStyle"
            [svgIcon]="widgetAttributes.widgetProperties.icon ?? ''"
          ></mat-icon>
        </span>
      </finxone-input>
    </div>
    <div class="py-8"></div>
    }
    <div class="row mx-0 row-items-gap pb-2">
      <!-- Show list of currencies available for the user to select, "disable" the currency if the user already has a currency account in that currency, only on currencyCloud provider -->
      @for (currency of currenciesData; track currency.code) {
      <div
        [innerHTML]="renderTemplate(currency) | safeHtml"
        style="width: 48.5%"
        [ngClass]="doesUserOwnCurrencyAccount(currency.code) ? 'disabled-currency' : ''"
        (click)="addCurrencyAccount(currency)"
      ></div>
      } @empty { @if (searchText.length) {
      <div class="empty-screen-msg">
        <div class="is-center mb-3">
          <mat-icon [svgIcon]="'exclamation-circle'"></mat-icon>
        </div>
        <p>
          No results found for <b>{{ '"' + searchText + '"' }}</b
          >. Check the spelling or try another search.
        </p>
      </div>
      } @else { There are no currencies selected for display. Please contact an Admin. } }
    </div>
  </div>
</div>
